import React, { useContext } from 'react'
import { Pagination, Navigation, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/free-mode";
import Container from '../../Container/Container'
import { DataContext } from '../../Context/Context'
import ProductCard0 from '../../ProductCardAll/ProductCard0/ProductCard0';
import './PopularProducts.css'

function PopularProducts() {
    const value = useContext(DataContext);
    const [products, setProducts] = value.products;
    return (
        <>
            <Container class1='container-fluid style-sec '>
                <div className="row rounded ">
                    <div className="col-12">
                        <h4>محصولات محبوب </h4>
                    </div>
                    {/* <div className="row sec-productSlider "> */}
                        <Swiper
                            slidesPerView={1}
                            breakpoints={{
                                500: { slidesPerView: 2},
                                768: { slidesPerView: 3 },
                                1000: { slidesPerView: 4 },
                                1200: { slidesPerView: 5 }
                            }}
                            spaceBetween={30}
                            freeMode={true}
                            navigation={true}
                            modules={[FreeMode, Pagination, Navigation]}
                            className="mySwiper swiperProsucts sec-productSlider"
                        >
                            {
                                products.map(product => (
                                    <SwiperSlide key={product._id} className='products-wrapper' >
                                        <ProductCard0 product={product} classes='swiper-product-card ' />
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    </div>
                {/* </div> */}
            </Container>
        </>
    )
}

export default PopularProducts